import espaBanner from './espa-banner.jpg';

export default espaBanner;
